<template>
  <div class="system-pageAddD" id="app" style="overflow-y: scroll;">
    <div v-if="isLoading" class="back-loading">数据加载中...</div>
    <mt-header title="车辆维修申请单">
      <mt-button icon="back" slot="left" @click.native="goBack">返回</mt-button>
    </mt-header>
    <div style="width: 21rem;  padding: 0 1rem;position: relative;top: 0;height: 100%;">
      <div class="userinfoAdd">
        <div style="border-bottom: 1px solid #e0d8d8">
          <van-field v-model="userName" label="申请人" readonly/>
        </div>
        <div style="border-bottom: 1px solid #e0d8d8">
          <van-field v-model="carNo" label="车牌号"/>
        </div>
        <mt-cell label="上次维修时间" @click.native="selectLastRepairTime">
          <div style="font-size: 1.2rem;color: black;">{{ lastRepairTime }}</div>
          <img
              style="width: 2rem; padding-right: 0.5rem"
              v-if="!lastRepairTime"
              src="@/assets/icons/svg/dateChoose.svg"
          />
          <div class="mint-field-clear" v-else @click.stop="clearLastRepairTime">
            <i class="mintui mintui-field-error"></i>
          </div>
        </mt-cell>
        <div style="border-bottom: 1px solid #e0d8d8">
          <van-field v-model="mileage" label="保养间隔里程"/>
        </div>
        <div style="border-bottom: 1px solid #e0d8d8">
          <label style="font-size: 1.2rem !important;font-weight: 700;color: #6d9eeb;height: 20px;margin-top: 20px;margin-left: 5px">维修类型</label>
          <div style=";display: flex">
            <van-checkbox v-model="qdType1" @change="typeChange('正常维修')" shape="square">正常维修</van-checkbox>
            <van-checkbox v-model="qdType2" @change="typeChange('事故维修')" shape="square">事故维修</van-checkbox>
            <van-checkbox v-model="qdType3" @change="typeChange('保养')" shape="square">保养</van-checkbox>
            <van-checkbox v-model="qdType4" @change="typeChange('装潢')" shape="square">装潢</van-checkbox>
          </div>
        </div>
        <div style="border-bottom: 1px solid #e0d8d8">
          <van-field v-model="address" label="维修保养地点"/>
        </div>
        <van-field name="uploader" label="附件">
          <template #input>
            <div  class="btn btn-default"style="position: relative; overflow: hidden;
              margin-top: 6px;">
              <i class="glyphicon glyphicon-open"></i> 上传附件
              <input type="file" name="filePath" style="opacity: 0; position: absolute;
               top: 12px; right: 0; " class='inpu' @change="fileListChange">
            </div>
          </template>
        </van-field>
        <van-field name="uploader" label="">
          <template #input>
            <div v-if="fileList.length!=0" style="display: flex; flex-direction: column;">
              <div
                  v-for="(item, idx) in fileList"
                  :key="idx"
                  style="display: flex; align-items: center; margin-bottom: 5px;">
                <span>{{ item.attachmentName }}</span><div class="delete-btn" @click.prevent="fileListdel(item)">x</div>
              </div>
            </div>
          </template>
        </van-field>
        <div style="border-bottom: 1px solid #e0d8d8">
          <label style="font-size: 1.6rem !important;font-weight: 700;color: #6d9eeb;height: 20px;margin-top: 20px;margin-left: 5px">维修项目及价格估算</label>
        </div>
        <div style="border-bottom: 1px solid #e0d8d8;display: flex">
          <label style="font-size: 1.2rem !important;font-weight: 700;color: #6d9eeb;height: 20px;margin-top: 20px;margin-left: 5px">
            维修项目&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp</label>
          <label style="font-size: 1.2rem !important;font-weight: 700;color: #6d9eeb;height: 20px;margin-top: 20px;margin-left: 5px">价格估算</label>
        </div>
        <div style="border-bottom: 1px solid #e0d8d8;display: flex">
          <input type="text" v-model="projcetNameOne" placeholder="" style="font-size: 1.2rem !important;font-weight: 700;color: #6d9eeb;height: 20px;margin-top: 10px;margin-bottom: 10px;margin-left: 5px;width: 175px;"/>
          <input type="number" v-model="priceOne" placeholder="" style="font-size: 1.2rem !important;font-weight: 700;color: #6d9eeb;height: 20px;margin-top: 10px;margin-bottom: 10px;margin-left: 5px;width: 175px;"/>
        </div>
        <div style="border-bottom: 1px solid #e0d8d8;display: flex">
          <input type="text" v-model="projcetNameTwo" style="font-size: 1.2rem !important;font-weight: 700;color: #6d9eeb;height: 20px;margin-top: 10px;margin-bottom: 10px;margin-left: 5px;width: 175px;"/>
          <input type="number" v-model="priceTwo"  style="font-size: 1.2rem !important;font-weight: 700;color: #6d9eeb;height: 20px;margin-top: 10px;margin-bottom: 10px;margin-left: 5px;width: 175px;"/>
        </div>
        <div style="border-bottom: 1px solid #e0d8d8;display: flex">
          <input type="text" v-model="projcetNameThree"  style="font-size: 1.2rem !important;font-weight: 700;color: #6d9eeb;height: 20px;margin-top: 10px;margin-bottom: 10px;margin-left: 5px;width: 175px;"/>
          <input type="number" v-model="priceThree"  style="font-size: 1.2rem !important;font-weight: 700;color: #6d9eeb;height: 20px;margin-top: 10px;margin-bottom: 10px;margin-left: 5px;width: 175px;"/>
        </div>
        <div style="border-bottom: 1px solid #e0d8d8">
          <van-field v-model="totalPrice" label="合计价格估算"/>
        </div>
        <van-field name="uploader"
                   label="审核人员">
          <template #input>
            <div style="color: black;">{{nameuser}}</div>
          </template>
        </van-field>
        <van-field
            label="情况说明"
            class="owntext"
            v-model="processDescribe"
            rows="2"
            autosize
            type="textarea"
            placeholder=""
            show-word-limit
        />
        <div style="display: flex; gap: 8px;">
          <div class="sub" @click.prevent="handelSubmit">提交</div>
          <div  class="sub" @click.prevent="caogaoSubmit">保存草稿</div>
        </div>
      </div>
    </div>
    <!-- 上次维修时间选择 -->
    <van-calendar
        v-model="lastRepairTimeVisible"
        type="single"
        :min-date="minDate"
        :max-date="new Date()"
        @confirm="onLastRepairTimeConfirm"
    >
    </van-calendar>
  </div>
</template>

<script>
import {Toast} from "mint-ui";
import {getLocalData} from "@/utils/sessionData";
import axios from "axios";
import request from "@/utils/keyCloakRequest";

export default {
  data() {
    return {
      fileList: [],
      fileIds: [],
      minDate: new Date(2024, 11, 1),
      currentStartDate: new Date(),
      processDescribe: "",
      userName: "",
      userId:"",
      isLoading: false,
      nameuser: '葛昊龙',//审核人姓名
      userInfo:{},
      carNo:'',
      lastRepairTime:'',			//上次维修时间
      mileage:'',
      address:'',
      type:'',
      editType:'',
      qdType1:'',qdType2:'',qdType3:'',qdType4:'',
      totalPrice:'',
      projcetNameOne:'',
      priceOne:'',
      projcetNameTwo:'',
      priceTwo:'',
      projcetNameThree:'',
      priceThree:'',
      lastRepairTimeVisible:false,
      route:'',
      item:{},
      projects:[]
    };
  },
  computed: {
  },
  async created() {
    this.userInfo = JSON.parse(getLocalData("userInfo"))
    this.userName = this.userInfo.userName
    this.userId = this.userInfo.userId
    this.lastRepairTime =this.formatDate(new Date())
    this.processId = this.$route.query.item==undefined?'':this.$route.query.item.processId
    if(this.processId){
      axios({
        url: process.env.VUE_APP_SSO_URL+"appRepairVehicleDetail?processId="+this.processId,
        method: "get",
      }).then(response => {
        this.item = response.data
        this.lastRepairTime = this.item.lastRepairTime
        this.carNo = this.item.carNo;
        this.mileage = this.item.mileage
        this.address = this.item.address;
        this.lastRepairTime = this.item.lastRepairTime
        this.totalPrice = this.item.totalPrice;
        this.editType = this.item.type
        if(this.editType.includes('正常维修')) {
          this.qdType1 = ['正常维修'];
        }
        if(this.editType.includes('事故维修')) {
          this.qdType2 = ['事故维修'];
        }
        if(this.editType.includes('保养')) {
          this.qdType3 = ['保养'];
        }
        if(this.editType.includes('装潢')) {
          this.qdType4 = ['装潢'];
        }
        this.processDescribe = this.item.processDescribe,
        this.fileIds = this.item.proFileid.split(",")
        this.projects = this.item.projects
        if(this.projects.length==1){
          this.projcetNameOne=this.projects[0].projcetName
              this.priceOne=this.projects[0].price
        }
        if(this.projects.length==2){
          this.projcetNameOne=this.projects[0].projcetName
          this.priceOne=this.projects[0].price
          this.projcetNameTwo=this.projects[1].projcetName
          this.priceTwo=this.projects[1].price
        }
        if(this.projects.length==3){
          this.projcetNameOne=this.projects[0].projcetName
          this.priceOne=this.projects[0].price
          this.projcetNameTwo=this.projects[1].projcetName
          this.priceTwo=this.projects[1].price
          this.projcetNameThree=this.projects[2].projcetName
          this.priceThree=this.projects[2].price
        }
        if(this.item.proFileid){
          request({
            url: "appDocumentFile?fileIds="+this.item.proFileid,
            method: "get"
          }).then(  response => {
            response.forEach(file => {
              this.fileList.push(file)
            });
          })
        }
      })
    }
    this.route =  this.$route.query.route
  },
  watch: {
  },
  methods: {
    fileListChange(event){
      const file = event.target.files[0]
      axios({
        url: process.env.VUE_APP_SSO_URL+"appSavePfile",
        method: "POST",
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: {file:file,userId:this.userId}
      }).then(  response => {
        this.fileList.push(response.data)
        this.fileIds.push(response.data.attachmentId)
      })
    },
    fileListdel(attachment){
      this.fileList.splice(this.fileList.indexOf(attachment),1)
      this.fileIds.splice(this.fileIds.indexOf(attachment.attachmentId),1)
    },
    typeChange(value) {
      let types = this.type ? this.type.split(',').filter(type => type.trim()) : [];
      // 查找value在数组中的索引
      const index = types.indexOf(value);
      // 如果找到了，就移除它
      if (index > -1) {
        types.splice(index, 1);
      } else {
        // 如果没有找到，则添加它
        types.push(value);
      }
      // 重新组合数组为字符串，并确保不以逗号开头或只有一个逗号
      this.type = types.join(',');
      // 如果type以逗号开头（虽然正常情况下不应该），则去除开头的逗号
      if (this.type.startsWith(',')) {
        this.type = this.type.slice(1);
      }
      // 如果type是空字符串，或者只包含一个逗号，则设置为空
      if (this.type === ',' || this.type === '') {
        this.type = '';
      }
    },
    selectLastRepairTime() {
      this.lastRepairTimeVisible = true;
    },
    onLastRepairTimeConfirm(value) {
      this.lastRepairTime = this.formatDate(value);
      this.lastRepairTimeVisible = false
    },
    // 清除时间
    clearLastRepairTime() {
      if (this.lastRepairTime) {
        this.lastRepairTime = '';
      }
    },
    formatDate(timestamp) {
      // 创建一个新的Date对象，使用时间戳初始化
      const date = new Date(timestamp);

      // 获取各个时间组件
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，需要加1
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');

      // 组合成所需的格式
      return `${year}-${month}-${day}`;
    },
    caogaoSubmit() {
      if (!this.lastRepairTime) {
        Toast({
          message: "请填写上次维修时间"
        });
        return;
      }
      if (!this.carNo) {
        Toast({
          message: "请填写车牌号"
        });
        return;
      }
      if (!this.mileage) {
        Toast({
          message: "请填写保养间隔里程"
        });
        return;
      }
      if (!this.address) {
        Toast({
          message: "请填写车辆维修保养地点"
        });
        return;
      }
      if (!this.type) {
        Toast({
          message: "请填写维修类型"
        });
        return;
      }
      if (!this.totalPrice) {
        Toast({
          message: "请填写合计价格估算"
        });
        return;
      }
      if (!this.processDescribe) {
        Toast({
          message: "请填写情况说明"
        });
        return;
      }
      let params = {
        processId : this.processId,
        nameuser : this.nameuser,
        processDescribe : this.processDescribe,	//流程申请原因内容
        userId : this.userId,			//流程申请人
        lastRepairTime : this.lastRepairTime,			//流程上次维修时间
        carNo:this.carNo,
        mileage:this.mileage,
        address:this.address,
        type:this.type,
        totalPrice:this.totalPrice,
        projcetNameOne:this.projcetNameOne,
        priceOne:this.priceOne,
        projcetNameTwo:this.projcetNameTwo,
        priceTwo:this.priceTwo,
        projcetNameThree:this.projcetNameThree,
        priceThree:this.priceThree,
        proFileid:this.fileIds.join(','),
        statusId:22
      };
      axios({
        url: process.env.VUE_APP_SSO_URL+"appRepairVehicle",
        method: "POST",
        data:params
      }).then(res => {
        if(res.data=='sucess'){
          Toast({
            message: "保存草稿成功",
            position: 'middle',
            iconClass: "icon icon-success"
          });
          this.goBack();
        }
        else {
          Toast({
            message: res.data,
            position: 'middle',
            iconClass: "icon icon-success"
          });
        }
      })
    },
    handelSubmit() {
      if (!this.lastRepairTime) {
        Toast({
          message: "请填写上次维修时间"
        });
        return;
      }
      if (!this.carNo) {
        Toast({
          message: "请填写车牌号"
        });
        return;
      }
      if (!this.mileage) {
        Toast({
          message: "请填写保养间隔里程"
        });
        return;
      }
      if (!this.address) {
        Toast({
          message: "请填写车辆维修保养地点"
        });
        return;
      }
      if (!this.type) {
        Toast({
          message: "请填写维修类型"
        });
        return;
      }
      if (!this.totalPrice) {
        Toast({
          message: "请填写合计价格估算"
        });
        return;
      }
      if (!this.processDescribe) {
        Toast({
          message: "请填写情况说明"
        });
        return;
      }
      let params = {
        processId : this.processId,
        nameuser : this.nameuser,
        processDescribe : this.processDescribe,	//流程申请原因内容
        userId : this.userId,			//流程申请人
        lastRepairTime : this.lastRepairTime,			//流程上次维修时间
        carNo:this.carNo,
        mileage:this.mileage,
        address:this.address,
        type:this.type,
        totalPrice:this.totalPrice,
        projcetNameOne:this.projcetNameOne,
        priceOne:this.priceOne,
        projcetNameTwo:this.projcetNameTwo,
        priceTwo:this.priceTwo,
        projcetNameThree:this.projcetNameThree,
        priceThree:this.priceThree,
        proFileid:this.fileIds.join(','),
        statusId:23
      };
      axios({
        url: process.env.VUE_APP_SSO_URL+"appRepairVehicle",
        method: "POST",
        data:params
      }).then(res => {
        if(res.data=='sucess'){
          Toast({
            message: "提交成功",
            position: 'middle',
            iconClass: "icon icon-success"
          });
          this.goBack();
        }
        else {
          Toast({
            message: res.data,
            position: 'middle',
            iconClass: "icon icon-success"
          });
        }
      })
    },
    goBack() {
      this.$router.push(this.route==undefined?"/procedure/addProcedure":this.route);
    }
  },
};
</script>

<style lang="less">
@color: #ffffff;
@border-rd: 10px;

html {
  overflow: hidden;
  height: 100%;
  background: #f5f5f5;
}
.line {
  height: 3rem;
  width: 0.013333rem;
  background: #6d9eeb;
}
.van-checkbox__icon {
  height: 2rem !important;
  font-size: 1rem !important;
  line-height: 1rem !important;
}
.delete-btn {
  color: red;
  cursor: pointer;
  margin-left: 50px;
}
.van-checkbox__label {
  margin-top: -1rem;
  opacity: 1;
  font-size: 1.16rem !important;
  line-height: 2rem;
}
body {
  display: block;
  margin: 0rem !important;
}
.app {
  /* padding: 0.5rem; */
  background-color: rgb(240, 240, 240, 0.75);
}
.van-field__control {
  line-height:  2rem;
  font-size: 1.5rem !important;
  margin-top: 10px;
}
.van-field__label {
  span{
    font-size: 1.2rem !important;
    font-weight: 700;
    color: #6d9eeb
  }
  width: 8.2rem;
  line-height:  1rem;
  font-size: 1rem !important;
}
.van-field__value {
  line-height:  3rem;
  font-size: 2rem !important;
}
.userinfoAdd {
  .mint-cell-label {
    font-size: 1.2rem !important;
    font-weight: 700;
    color: #6d9eeb !important;
    margin-left: -20px;
  }
  .owntext {
    padding: 0 !important;

    .van-field__control {
      height: 300px !important;
    }
    .van-field__word-limit {
      height: 75px;
      line-height: 75px;
      margin-bottom: 30px;
    }
  }
  .ownupload {
    margin: 0.5rem 0;
    .van-uploader__preview {
      margin: 10px 10px 10px 0;
      .van-image__error-icon {
        font-size: 90px;
      }
    }
    .van-uploader__preview-image,
    .van-uploader__upload {
      width: 200px;
      height: 200px;
      border: 1px dashed #ccc;
      .van-uploader__upload-icon {
        font-size: 90px;
      }
    }
    .van-uploader__preview-delete {
      width: 50px;
      height: 50px;
      .van-uploader__preview-delete-icon {
        font-size: 55px;
      }
    }
  }
  .van-cell {
    align-items: center;
    .van-field__label {
      width: 7.333333rem;
      font-size: 60px;
      height: 20px;
      line-height: 20px;
      color: #382c2c;
    }
  }
  .van-field__body {
    input {
      border: none !important;
      color: black;
    }
    textarea {
      padding-left: 30px;
    }
  }
  .sub {
    width: 50%;
    height: 200px;
    line-height: 200px;
    margin-top: 20px;
    font-size: 75px;
    background: #5f9cf5;
    border-radius: 50px 50px 50px 50px;
    text-align: center;
    cursor: pointer;
    color: #e5f4f9;
  }
}
.system-pageAddD {
  overflow-y: scroll;
  width: 100%;
  height: 100vh;
  background-color: #fff;
  font-family: "PingFangSC-Regular";
}

/** 加载中 */
.back-loading {
  width: 100%;
  height: 100%;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  text-align: center;
  line-height: 25rem;
  font-size: 1rem;
  color: grey;
}
.van-field__error-message {
  line-height: 1.3rem;
}
.custom-list {
  overflow-y: auto; /* 如果内容超出容器高度，则启用垂直滚动 */
  padding: 0;
  margin: 0;
  list-style: none; /* 移除默认的列表样式 */
  background-color: #fff; /* 背景颜色 */
  border-radius: 4px; /* 圆角 */
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}
.list-item {
  line-height: 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  border-bottom: 1px solid #ebeef5; /* 分隔线 */
}
.list-item input:disabled {
  opacity: 0.5; /* 置灰效果 */
  cursor: not-allowed; /* 禁止点击的鼠标样式 */
}
.item-content{
  width: 21rem;
}
/* 为title定义样式，这通常是列表项中的主标题 */
.title {
  font-size: 1.213333rem; /* 字体大小 */
  font-weight: bold; /* 加粗 */
  color: #333; /* 字体颜色 */
  margin-bottom: 8px; /* 与副标题之间的间距 */
}

/* 为subtitle定义样式，这通常是列表项中的副标题或额外信息 */
.subtitle {
  font-size: 1.213333rem; /* 字体大小 */
  color: #666; /* 字体颜色 */
}

/* 额外的样式，例如复选框 */
.list-item input[type="checkbox"] {
  margin-top: 0; /* 移除复选框上方的默认间距 */
  margin-right: 16px; /* 复选框与文本之间的间距 */
}
.van-picker__toolbar {
  height: 1.586667rem;
}
.van-picker__cancel, .van-picker__confirm {
  padding: 0 0.213333rem;
  font-size: 1.186667rem;
}
.van-picker__title {
  font-size: 1.213333rem;
  line-height: 1.266667rem;
}
.van-picker-column__item {
  line-height: 1rem
}
.van-picker-column {
  font-size: .8rem;
}
.van-cell {
  font-size: 0.9rem;
  line-height: 1.32rem;
}
.van-field__control:read-only {
  font-size: .8rem;
}
</style>
